import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/home.vue'
import houtai_jingru from '../views/houtai_jingru/houtai_jingru.vue'
Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location){
  return originalPush.call(this , location).catch(err=>err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
  return originalReplace.call(this , location).catch(err=>err)
}
const routes = [
  {path: '/',name: 'home',component: Home,redirect: '/bwIndex',require:'/bwIndex',
    children:[
      {path:'/bwIndex', component: () => import("../views/bw-index/bwIndex.vue"), meta: { title: '首页'}},
      {path:'/ruzhu',component:()=>import("../views/ruzhu/ruzhu.vue"), meta:{title:'入驻'}},
      {path:'/houtai',component:()=>import("../views/houtai/houtai.vue"), meta:{title:'商家后台'}},
      {path:'/bwJoin',component:()=>import("../views/bw-join/bwJoin.vue"), meta:{title:'联系我们'}},
      {path:'/zixun',component:()=>import("../views/zixun/zixun.vue"), meta:{title:'资讯'}},
      {path: '/houtai_jingru',component: houtai_jingru,
        children:[
          {path:'/shouye',name: 'houtai_name',component:()=>import("@/views/shouye/shouye.vue"), meta:{title:'首页'}}, 
          {path: '/shangpin_fabu', name: 'houtai_name', component: () => import("@/views/shangpin_fabu/shangpin_fabu.vue"), meta: { title: '首页' } },
          {path: '/shangpin_guanli', name: 'houtai_name', component: () => import("@/views/shangpin_guanli/shangpin_guanli.vue"), meta: { title: '首页' } },
          {path: '/dingdan', name: 'houtai_name', component: () => import("@/views/dingdan/dingdan.vue"), meta: { title: '首页' } },
          {path: '/shangchuan01', name: 'houtai_name', component: () => import("@/views/shangchuan01/shangchuan01.vue"), meta: { title: '首页' } },
          {path: '/shangchuan02', name: 'houtai_name', component: () => import("@/views/shangchuan02/shangchuan02.vue"), meta: { title: '首页' } },
          {path: '/set_taocan',name: 'houtai_name',component:()=>import("@/views/set_taocan/set_taocan.vue"), meta:{title:'首页'}},
          {path: '/qijiandian', name: 'houtai_name', component: () => import("@/views/qijiandian/qijiandian.vue"), meta: { title: '首页' } },
          {path: '/nianshen', name: 'houtai_name', component: () => import("@/views/nianshen/nianshen.vue"), meta: { title: '首页' } },
          {path: '/tuiguang_Set',name: 'houtai_name',component:()=>import("@/views/tuiguang_Set/tuiguang_Set.vue"), meta:{title:'首页'}},
          {path: '/shuomingshu', name: 'houtai_name', component: () => import("@/views/shuomingshu/shuomingshu.vue"), meta: { title: '首页' } },
          {path: '/set_tuiguang',name: 'houtai_name',component:()=>import("@/views/set_tuiguang/set_tuiguang.vue"), meta:{title:'首页'}},
        ]
      },
    ]
  }, 
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
})

export default router
